import React, { useContext } from 'react'
import cx from 'classnames'
import PlaceholderImage from '@softwaredev_cegeka/stix-core/dist/components/PlaceholderImage'
import ThemeContext from '@softwaredev_cegeka/stix-core/dist/components/ThemeProvider/ThemeContext'
import useTranslations from 'src/hooks/useTranslations'
import logoBouncing from 'src/assets/images/logo-horizon-bouncing.svg'
import styles from 'src/components/UnauthorizedCard/unauthorizedCard.module.scss'

const UnauthorizedCard = props => {
    const { t } = useTranslations('UnauthorizedCard', 'UnauthorizedCard')
    const { activeTheme } = useContext(ThemeContext)

    return (
        <div
            className={cx('page-body', 'error-page', styles.pageWrapper, {
                [styles.globalUnauth]: props.globalAuth,
            })}
        >
            <div className={styles.contentWrapper}>
                <PlaceholderImage
                    width={310}
                    src={activeTheme?.config?.unauthorizedLogo ?? logoBouncing}
                    alt={t('Horizon logo bouncing')}
                />
                <div className={styles.textWrapper}>
                    <h1>{t('Ooops...')}</h1>
                    <h2>{t('No access')}</h2>
                    <h3>{t('You are not authorized to access this page.')}</h3>
                </div>
            </div>
        </div>
    )
}

export default UnauthorizedCard
